import styled from "styled-components"

export default styled.div`
  text-align: center;
  padding-top: 106px;
  > * {
    margin-bottom: 30px;
  }
`
